import React from "react";

import { cardClass, inputClass, labelClass } from "./utils/listingStyles";

/**
 * The two image panels of the listings screen: the gallery shown while an
 * existing listing is being edited, and the upload panel shown right after
 * a listing was created.
 *
 * Moved verbatim out of AdminListingsPage.js (L1 extraction). Image
 * behaviour is deliberately untouched (discovery risk R3): no set-primary,
 * no reorder, no change to how uploads or deletes are issued.
 */
export default function ListingImagesSection({
  editingListingId,
  showForm,
  createdListingId,
  existingImages,
  uploadedImages,
  deletingImageId,
  editUploading,
  uploadingImages,
  onDeleteExistingImage,
  onEditImageUpload,
  onImageUpload,
  onDone,
}) {
  return (
    <>
  {editingListingId && showForm && (
    <div className={cardClass} style={{ marginTop: "16px" }}>
      <h3 className="mb-3 text-[16px] font-bold text-[#0f172a] dark:text-[#eef2ff]">
        Bilder verwalten
      </h3>
      {existingImages.length > 0 ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
            gap: "12px",
            marginBottom: "12px",
          }}
        >
          {existingImages.map((img) => {
            const isDeleting = deletingImageId === img.id;
            return (
              <div key={img.id} style={{ position: "relative" }}>
                <img
                  src={img.url}
                  alt=""
                  style={{ width: "100%", height: "100px", objectFit: "cover", borderRadius: "8px" }}
                />
                {img.is_main && (
                  <span
                    style={{
                      position: "absolute",
                      top: 4,
                      left: 4,
                      background: "#4ade80",
                      color: "#000",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      fontSize: "10px",
                      fontWeight: 700,
                    }}
                  >
                    Hauptbild
                  </span>
                )}
                <button
                  type="button"
                  onClick={() => onDeleteExistingImage(img.id)}
                  disabled={isDeleting}
                  style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    background: "rgba(248, 113, 113, 0.9)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "2px 8px",
                    fontSize: "11px",
                    fontWeight: 700,
                    cursor: isDeleting ? "not-allowed" : "pointer",
                    opacity: isDeleting ? 0.6 : 1,
                  }}
                >
                  {isDeleting ? "…" : "✕ Löschen"}
                </button>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="mb-3 text-[13px] text-[#64748b] dark:text-[#6b7a9a]">
          Noch keine Bilder für dieses Listing.
        </p>
      )}
      <label className={labelClass}>Neue Bilder hinzufügen</label>
      <input
        type="file"
        multiple
        accept="image/jpeg,image/png,image/webp"
        onChange={(e) => onEditImageUpload(Array.from(e.target.files))}
        disabled={editUploading}
        className={inputClass}
      />
      {editUploading && (
        <p className="mt-2 text-[13px] text-[#64748b] dark:text-[#6b7a9a]">Wird hochgeladen…</p>
      )}
    </div>
  )}

  {createdListingId && (
    <div className={cardClass} style={{ marginTop: "16px" }}>
      <h3 className="mb-3 text-[16px] font-bold text-[#0f172a] dark:text-[#eef2ff]">
        Bilder hochladen
      </h3>
      <input
        type="file"
        multiple
        accept="image/jpeg,image/png,image/webp"
        onChange={(e) => onImageUpload(Array.from(e.target.files))}
        disabled={uploadingImages}
        className={inputClass}
      />
      {uploadingImages && (
        <p className="mt-2 text-[13px] text-[#64748b] dark:text-[#6b7a9a]">Wird hochgeladen…</p>
      )}
      {uploadedImages.length > 0 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
            gap: "12px",
            marginTop: "12px",
          }}
        >
          {uploadedImages.map((img) => (
            <div key={img.id} style={{ position: "relative" }}>
              <img
                src={img.url}
                alt=""
                style={{ width: "100%", height: "100px", objectFit: "cover", borderRadius: "8px" }}
              />
              {img.is_main && (
                <span
                  style={{
                    position: "absolute",
                    top: 4,
                    left: 4,
                    background: "#4ade80",
                    color: "#000",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontSize: "10px",
                    fontWeight: 700,
                  }}
                >
                  Hauptbild
                </span>
              )}
            </div>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={onDone}
        className="mt-3 rounded-lg bg-sky-600 px-4 py-2 text-sm font-semibold text-white hover:bg-sky-700"
      >
        Fertig — neues Listing anlegen
      </button>
    </div>
  )}
    </>
  );
}
